import $ from 'jquery';

import {
	getDOMElements
}                         from '../common/utilities.js';

import { getActionsOrder } from '@builder-legacy/item/sortability/utilities';

import ItemHeaderMenu     from './action-menu.js';
import ItemHeaderIcon     from './integration-icon.js';
import ItemHeaderTag      from './integration-name.js';
import ItemHeaderSentence from './sentence.js';

import Field              from '../field';

import Actions            from './actions.js';

class Closures {

	constructor( label ){
		// Create console group
		// console.group( 'Closures' );

		// Get metabox
		this.elements = {
			$metabox: getDOMElements( 'metabox', { type: 'action' })
		}

		// Create closures. It's important to understand that we're going to create all the available closures, not only those already added to the item
		// That's why we create a separate file instead of using Item.js
		$.each( UncannyAutomator.closures, ( key, closure ) => this.createClosure( closure, label ) );

		// Close console group
		// console.groupEnd();
	}

	createClosure( closure, label ){
		// Variable to check later if this closure already was added to the recipe
		let wasAdded = false;

		// Container
		let $container = $( `
			<div class="metabox__footer metabox__closures"></div>
		` );

		// Checkbox attributes. We're going to use this to create our checkbox later.
		let checkboxAttributes = {
			label:              label,
			formElementClass:   'form-element--nomargin'
		}

		// Check if this closure already was added to the recipe
		let closureInRecipe = this.getClosureByCodeFromItemsObject( closure.code );

		if ( _uo.utility.isDefined( closureInRecipe ) ){
			wasAdded = true;

			checkboxAttributes.currentValue = true;
			checkboxAttributes.itemid       = closureInRecipe.id;
		}

		// Create checkbox
		let checkboxField = new Field( 'checkbox', checkboxAttributes ),
			$checkbox      = checkboxField.getFormElement();

		// Bind changes
		$checkbox.on( 'change', function(){
			let isChecked = checkboxField.getValue();
			checkboxField.startLoadingAnimation();

			// Check if it's checked
			if ( isChecked ){
				// Add item to the recipe
				UncannyAutomator._core.recipe.item.createItem( 
					'closure', 
					closure.code,
					{
						parentID: UncannyAutomator._recipe.recipe_id,
						actionsOrder: getActionsOrder(),
						defaultMeta: {
							integration:	   closure.integration,
							integration_name: UncannyAutomator.integrations[ closure.integration ].name,
							sentence:         closure.sentence,
							type:             'free'
						}
					}
				).then( response => {
					new Actions();

					// Check if the ID of the new item is defined
					if ( _uo.utility.isDefined( response.post_ID ) ){
						// Get item form element
						const $newItem = getDOMElements( 'item', {
							id: response.post_ID
						});

						// Get first token and trigger a click
						$newItem.item.find( '.item-title__token:not(.item-title__token--filled)' ).first().trigger( 'click' );
					}
				} ).catch( error => {
					// Stop the loading animation
					checkboxField.stopLoadingAnimation();

					// Change back the value of the checkbox
					checkboxField.setValue( false, false );
				} );
			}
			else {
				UncannyAutomator._core.recipe.item.deleteItem(
					'closure',
					closureInRecipe.id
				).catch( error => {
					console.log( error );

					new Actions();
				} );
			}
		});

		// Append checkbox to the container
		$container.append( $checkbox );

		// Create toggle section
		let $toggleContent = $( '<div/>', { 'class': 'uo-toggle uo-toggle--show' });

		// Check if it was already added. In that case show it
		if ( wasAdded ){
			$toggleContent.addClass( 'uo-toggle--show' );

			let $item = $( '<div/>', {
				'class':   'item item--closure item--margintop uap-item uap-item--closure uap-item--margintop',
				'data-id': closureInRecipe.id
			});

			// Add header
			$item.append( this.createInnerContent(
				UncannyAutomator.recipe.items[ closureInRecipe.id ].integrationCode,
				'closure',
				closure.code,
				closureInRecipe.id,
			) );

			$toggleContent.append( $item );
		}
	
		$container.append( $toggleContent );

		// Append everything to the metabox
		this.elements.$metabox.append( $container );
	}

	/**
	 * Creates item header
	 * 
	 * @since 0.5
	 *
	 * @param {String}    integrationCode - The integration code
	 * @param {String}    itemType - The item type: 'trigger', 'action' or 'closure'
	 * @param {String}    itemCode - The code of the item
	 * @param {int}       itemId - The ID of the item
	 */
	createInnerContent( integrationCode, itemType, itemCode, itemId ){
		// Get content
		const content = {
			// Icon. The integration icon
			$icon: new ItemHeaderIcon( integrationCode ),

			// Integration name tag
			$integrationNameTag: new ItemHeaderTag( {
				integrationId: integrationCode
			} ),

			// The action menu. The three dots on the upper right corner.
			$actionMenu: new ItemHeaderMenu( itemType, integrationCode, itemCode, itemId ),

			// Closure sentence
			$sentence: new ItemHeaderSentence( itemType, integrationCode, itemCode, itemId )
		}

		// Create wrapper
		const $template = document.createElement( 'div' );
		$template.classList.add( 'uap-item-inner' );

		// Add template
		$template.innerHTML = `
			<div class="uap-item-sidebar"></div>
			<div class="uap-item-top-header">
				<div class="uap-item-top-header-left"></div>
				<div class="uap-item-top-header-right"></div>
			</div>
			<div class="uap-item-main"></div>
			<div class="uap-item-inner-content"></div>
		`;

		// Icon. The integration icon
		$template.querySelector( '.uap-item-sidebar' )
			.appendChild( content.$icon );

		// Add integration name tag
		$template.querySelector( '.uap-item-top-header-left' )
			.appendChild( content.$integrationNameTag );

		// Add action menu
		$template.querySelector( '.uap-item-top-header-right' )
			.appendChild( content.$actionMenu.get(0) );

		// The sentence of the closure
		$template.querySelector( '.uap-item-main' )
			.appendChild( content.$sentence.get(0) );

		// Return the content
		return $template;
	}

	getClosureByCodeFromItemsObject( code ){
		let theItem;

		$.each( UncannyAutomator.recipe.items, function( itemID, item ){
			if ( item.itemCode == code ){
				theItem = item;
			}
		})

		return theItem;
	}
}

export default Closures;